import RootLayout from "./layouts/root-layout";
import ScrollToTop from "./globals/scroll-to-top";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { prefetchHeaderCategoriesFast } from "./adminApi";
import { ensureCustomJsInitialized } from "./globals/constants";
import "react-toastify/dist/ReactToastify.css";

function App() {

  useEffect(() => {
    let cancelled = false;

    const runNonCriticalInit = () => {
      if (cancelled) return;

      ensureCustomJsInitialized().catch(() => {
        // Keep app interactive even if legacy script init fails.
      });
      prefetchHeaderCategoriesFast();
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(runNonCriticalInit, {
        timeout: 1200,
      });
      return () => {
        cancelled = true;
        window.cancelIdleCallback(idleId);
      };
    }

    const timeoutId = window.setTimeout(runNonCriticalInit, 250);
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <ScrollToTop />
      <RootLayout />
    </>
  )
}

export default App;
